import React from 'react'
import Openhousepage from '../components/OpenHouse'
import Footer from '../components/footer'
export default function OpenHouse() {
  return (
    <div>
      <Openhousepage />
      <Footer />
    </div>
  )
}
